import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";

import { IStoreState } from "../../../../reducers/types";
import {
  getAdultsCount,
  getChildren,
  getFromDate,
  getUntilDate,
} from "../../../search/reducer";
import { WishlistManagementModal } from "./component";
import { getHotelsAvailabilityPetsCount } from "../../../availability/reducer";

interface IStateProps {
  fromDate: Date | null;
  untilDate: Date | null;
  adultsCount: number;
  childrenCount: number[];
  searchedPetsCount: number;
}

const mapStateToProps = (state: IStoreState): IStateProps => ({
  fromDate: getFromDate(state),
  untilDate: getUntilDate(state),
  adultsCount: getAdultsCount(state),
  childrenCount: getChildren(state),
  searchedPetsCount: getHotelsAvailabilityPetsCount(state),
});

const connector = connect(mapStateToProps);

export type WishlistManagementModalConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedWishlistManagementModal = withRouter(
  connector(WishlistManagementModal)
);
